import { CircularProgress } from '@mui/material';
import {
  SaveButtonDisplayMsg,
  StyledSaveButton,
  SaveButtonWrapper,
} from '@styles/StyledButtons';

export interface NewSaveButtonProps {
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  onClick?: () => void;
  label?: string;
  successLabel?: string;
  isLoading?: boolean;
  top?: string;
  right?: string;
  width?: string;
  displayMessage?: string;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  position?: string;
  size?: 'small' | 'medium' | 'large';
  minHeight?: string;
}

export const SaveButton = ({
  type = 'submit',
  disabled = false,
  label = 'Save',
  isLoading,
  onClick,
  top,
  right,
  width,
  displayMessage,
  minHeight,
  size = 'medium',
  variant = 'contained',
  color = 'success',
  position,
}: NewSaveButtonProps) => (
  <SaveButtonWrapper top={top} right={right} position={position}>
    {!disabled && displayMessage && <SaveButtonDisplayMsg>{displayMessage}</SaveButtonDisplayMsg>}
   
    <StyledSaveButton
      type={onClick ? 'button' : type}
      disabled={isLoading || disabled}
      variant={variant}
      color={color}
      width={width}
      size={size}
      minHeight={minHeight}
      {...(onClick && { onClick: onClick })}
    >
      {isLoading ? <CircularProgress size={25} color="inherit" /> : label}
    </StyledSaveButton>
  </SaveButtonWrapper>
);
